import { render, staticRenderFns } from "./DirectUpload.vue?vue&type=template&id=6465b636"
import script from "./DirectUpload.vue?vue&type=script&lang=js"
export * from "./DirectUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports